import { observerEpicHelper } from 'epics/helpers'
import { Constants as Client } from 'actions/shared/client'
import { Actions as PageActions } from 'actions/page'
import { updateAppUrl } from 'lib/url/route'
import { getPagePath } from 'selectors/page'
import { Actions as AlgoliaDataActions } from 'actions/algolia2/data'
import { DEFAULT_APP } from '../helpers/constants'
import { Constants } from '../actions'
import { getDefaultCollectionType, getAlgoliaSlugifyDictionary } from '../selectors/algolia'
export const getClientSideDataEpic = observerEpicHelper(
  [Client.NEW_CLIENT_COMPLETE],
  async ({ action, observer, store }) => {
    const { form } = getPagePath({ ...store.value })
    observer.next(
      PageActions.SET_DATA({
        form,
      })
    )
    observer.complete()
  }
)
export const updateUrlEpic = observerEpicHelper(
  [Constants.UPDATE_URL],
  async ({ action, observer, store }) => {
    const currentPage = getPagePath({ ...store.value })

    // Update If Page has CHANGED/Different
    if (currentPage !== action.payload) {
      const href = action.payload
      const app = DEFAULT_APP
      updateAppUrl({
        app,
        href,
      })
    }

    observer.complete()
  }
)
export const clientsideTransitionsEpic = observerEpicHelper(
  [Constants.CLIENTSIDE_TRANSITION],
  async ({ action, observer, store }) => {
    const defaultCollectionType = getDefaultCollectionType({ ...store.value })
    // in component fire navigate epic
    // for payload pass in slugify version of tab name
    const href = action.payload || defaultCollectionType
    observer.next(PageActions.SET_PATH(href))
    // steps
    // get dictionary from store
    // const slugifyDictionary = getSlugifyDictionary({ ...store.value })
    const algoliaSlugifyDictionary = getAlgoliaSlugifyDictionary({ ...store.value })
    // map through dictionary and convert slugified href to falgolia filter value
    // Ex: new-this-week -> 6
    const algoliaFacetValues = algoliaSlugifyDictionary[href]
    // update selected facets
    observer.next(
      AlgoliaDataActions.SET_SELECTED_FACETS({
        collection_types_ids: algoliaFacetValues,
      })
    )
    // call fetch algolia data
    observer.next(AlgoliaDataActions.FETCH_DATA(href))
    observer.complete()
  }
)
export default [clientsideTransitionsEpic, getClientSideDataEpic, updateUrlEpic]
